const $win = $(window);

export const equalizeTitlesHeight = () => {
  $('.js-articles-row').each(function() {
    const $titles = $(this).find('.js-article-title');

    if ($titles.length > 1) {
      if ($win.width() > 767) {
        $titles.css('height', 'auto');
        const height = Math.max.apply(
          null,
          $titles
            .map(function() {
              return $(this).outerHeight();
            })
            .get()
        );

        $titles.css('height', `${height}px`);
      } else {
        $titles.css('height', 'auto');
      }
    }
  });
};

$win.on('resize orientationchange', function() {
  equalizeTitlesHeight();
});

equalizeTitlesHeight();
